module.exports = {
  SETREPORT: 'SETREPORT',
  SETREPORTLOADING: 'SETREPORTLOADING',
  SET_FREQUENT_REPORTS: 'SET_FREQUENT_REPORTS',
  SET_REPORT_REQUEST_LIST: 'SET_REPORT_REQUEST_LIST',
}



// WEBPACK FOOTER //
// ./src/types/insights.js